<h1 mat-dialog-title>Wort erstellen</h1>
<mat-dialog-content class="w800 custom-scrollbar">
  <app-folder-usage-hint [entryId]="id" type="VOCAB_ENTRY"></app-folder-usage-hint>

  <mat-vertical-stepper #stepper [linear]=true>
    <!-- basic word attributes-->
    <mat-step [stepControl]="firstFormGroup" label="Allgemeine Informationen">
      <div class="pad-top8">
        <form [formGroup]="firstFormGroup">
          <div>
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Begriff</mat-label>
              <input (change)="setAsCompleted()" formControlName="wordCtrl" matInput placeholder="" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Rezeptiv</mat-label>
              <mat-select formControlName="receptiveCtrl" placeholder="">
                <mat-option>&mdash;</mat-option>
                @for (option of levelList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32">
              <mat-label>Produktiv</mat-label>
              <mat-select formControlName="productiveCtrl" placeholder="">
                <mat-option>&mdash;</mat-option>
                @for (option of levelList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Variante</mat-label>
              <mat-select formControlName="variantsCtrl" multiple placeholder="" (selectionChange)="onVariantsChange($event)">
                @for (option of countryList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w49">
              <mat-label>Wortart</mat-label>
              <mat-select (selectionChange)="changeWordType($event)" formControlName="typeCtrl" placeholder="">
                <mat-option>&mdash;</mat-option>
                @for (option of typeList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Test</mat-label>
              <input [matAutocomplete]="auto" formControlName="examCtrl" matInput placeholder="">
              <mat-autocomplete #auto="matAutocomplete">
                @for (filteredTest of filteredTests | async; track filteredTest) {
                  <mat-option [value]="filteredTest">
                    {{ filteredTest }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div (click)="openCategorySelectionDialog()" tabindex="0" class="w49">
              <mat-form-field appearance="outline" class="w100">
                <mat-label>Thema</mat-label>
                <mat-select formControlName="categoryCtrl" multiple placeholder="" required>
                  @for (option of selectedCategory; track option) {
                    <mat-option [value]="option?.id">
                      {{ option?.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div>
          <button matStepperNext color="primary" mat-raised-button>Weiter</button>
        </div>
      </div>
    </mat-step>
    <!-- Nomen word attributes-->
    @if (firstFormGroup.controls.typeCtrl?.value === 'Nomen') {
      <mat-step [stepControl]="secondFormGroup" label="Nomen Informationen">
        <div class="pad-top8">
          <form [formGroup]="secondFormGroup">
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Artikel</mat-label>
              <mat-select formControlName="articlesCtrl" multiple placeholder="">
                <mat-option value="der">der</mat-option>
                <mat-option value="die">die</mat-option>
                <mat-option value="das">das</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Numerus</mat-label>
              <mat-select formControlName="numeralCtrl" placeholder="">
                <mat-option></mat-option>
                <mat-option value="singular">Singular</mat-option>
                <mat-option value="plural">Plural</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32">
              <mat-label>Plural</mat-label>
              <input formControlName="pluralCtrl" matInput placeholder="">
            </mat-form-field>
          </form>
          <div style="display: flex; flex-direction: row; gap: 10px;">
            <button mat-raised-button matStepperPrevious>Zurück</button>
            <button color="primary" mat-raised-button matStepperNext>Weiter</button>
          </div>
        </div>
      </mat-step>
    }
    <!-- Verb word attributes-->
    @if (firstFormGroup.controls.typeCtrl?.value === 'Verb') {
      <mat-step [stepControl]="thirdFormGroup" label="Verb Informationen">
        <div class="pad-top8">
          <form [formGroup]="thirdFormGroup">
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Präsens</mat-label>
              <input formControlName="presenceCtrl" matInput placeholder="">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32 marg-right2">
              <mat-label>Perfekt</mat-label>
              <input formControlName="perfectCtrl" matInput placeholder="">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w32">
              <mat-label>Präteritum</mat-label>
              <input formControlName="pastCtrl" matInput placeholder="">
            </mat-form-field>
          </form>
          <div style="display: flex; flex-direction: row; gap: 10px;">
            <button mat-raised-button matStepperPrevious>Zurück</button>
            <button color="primary" mat-raised-button matStepperNext>Weiter</button>
          </div>
        </div>
      </mat-step>
    }
    <!-- Other word attributes-->
    <mat-step [stepControl]="fourthFormGroup" label="Kommentar und Beispiele">
      <form [formGroup]="fourthFormGroup">
        <mat-form-field appearance="outline" class="w100 pad-top8">
          <mat-label>Kommentar</mat-label>
          <textarea formControlName="commentCtrl" class="custom-scrollbar" matInput placeholder=""></textarea>
        </mat-form-field>

        <button (click)="addExample()" color="primary" mat-raised-button>Beispielsatz hinzufügen</button>
        <ul formArrayName="examples" style="padding: 0;">
          @for (e of examples().controls; track e; let i = $index) {
            <li [formGroupName]="i">
              <mat-form-field appearance="outline" class="w100">
                <mat-label>Beispielsatz {{ i + 1 }}</mat-label>
                <textarea formControlName="example" class="custom-scrollbar" matInput placeholder=""></textarea>
              </mat-form-field>
            </li>
          }
        </ul>
      </form>
      <div>
        <div style="display: flex; flex-direction: row; gap: 10px;">
          <button mat-raised-button matStepperPrevious>Zurück</button>
          <button color="primary" mat-raised-button matStepperNext>Weiter</button>
        </div>
      </div>
    </mat-step>
    <!-- Reference -->
    <mat-step label="Verweise">
      <app-reference-table [entry]="references" [editMode]="true" [clickableRefs]="false" [selfId]="id" [selfType]="'vocab_entry'" (entryChange)="handleReferenceChange($event)"></app-reference-table>
      <button mat-raised-button matStepperPrevious>Zurück</button>
    </mat-step>
  </mat-vertical-stepper>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="createWord()" [disabled]="
    firstFormGroup.controls.firstCtrl?.hasError('required')" color="primary"
          mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
